import SideDrawer from './SideDrawer.vue'

export default SideDrawer
